var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "multi-selection-table-container scroll-fire-fox" },
    [
      !_vm.loading && _vm.fields.length > 0 && _vm.objects.length > 0
        ? _c(
            "table",
            { staticClass: "multi-selection-table" },
            [
              _c(
                "tr",
                { staticClass: "table-header" },
                [
                  _c("th", { staticClass: "object-index" }),
                  _vm._v(" "),
                  _c("th", [_vm._v("\n        ID\n      ")]),
                  _vm._v(" "),
                  _vm._l(_vm.fields, function(field, index) {
                    return _c(
                      "th",
                      {
                        key: index + field.label,
                        class: { required: field.required }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.getFieldLabel(field)) +
                            "\n      "
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_vm.objects, function(object, objectIndex) {
                return _c(
                  "tr",
                  {
                    staticClass: "table-body",
                    class: { selected: _vm.selected.includes(objectIndex) }
                  },
                  [
                    _c(
                      "td",
                      {
                        staticClass: "object-index",
                        on: {
                          click: function($event) {
                            return _vm.select(objectIndex, $event)
                          }
                        }
                      },
                      [_vm._v("\n        " + _vm._s(objectIndex) + "\n      ")]
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "input-disabled" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(object[_vm.initials + "_id"]) +
                          "\n      "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.fields, function(field, fieldIndex) {
                      return _c(
                        "td",
                        {
                          key: fieldIndex + field.label,
                          class: _vm.editMode ? field.size : ""
                        },
                        [
                          !_vm.editMode && field.input_type !== "checkbox"
                            ? _c("div", { staticClass: "input-disabled" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.getNonEditableValue(object, field)
                                    ) +
                                    "\n        "
                                )
                              ])
                            : _vm.isStandardInput(field.input_type)
                            ? _c("input", {
                                staticClass: "table-input",
                                class: {
                                  "required-not-filled": _vm.requiredWasMadeEmpty(
                                    objectIndex,
                                    field
                                  )
                                },
                                attrs: {
                                  type: _vm.getSpecificStandardInputType(
                                    field.input_type
                                  ),
                                  disabled: field.disable
                                },
                                domProps: {
                                  value: _vm.getValue(object, field)
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.setValue(
                                      objectIndex,
                                      field,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            : field.input_type === "select"
                            ? _c("treeselect", {
                                staticClass: "multi-selection-select",
                                class: {
                                  "required-not-filled": _vm.requiredWasMadeEmpty(
                                    objectIndex,
                                    field
                                  )
                                },
                                attrs: {
                                  value: _vm.getValue(object, field),
                                  options: _vm.options[field.select_list_name],
                                  disabled: field.disable,
                                  clearable: !field.required,
                                  disableFuzzyMatching: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setValue(
                                      objectIndex,
                                      field,
                                      $event
                                    )
                                  }
                                }
                              })
                            : field.input_type === "radio"
                            ? _c("treeselect", {
                                staticClass: "multi-selection-select",
                                class: {
                                  "required-not-filled": _vm.requiredWasMadeEmpty(
                                    objectIndex,
                                    field
                                  )
                                },
                                attrs: {
                                  value: _vm.getValue(object, field),
                                  options: _vm.options[field.var_name],
                                  disabled: field.disable,
                                  clearable: false,
                                  disableFuzzyMatching: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.setValue(
                                      objectIndex,
                                      field,
                                      $event
                                    )
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          field.input_type === "checkbox"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "multi-selection-checkbox-container",
                                  class: {
                                    "required-not-filled": _vm.requiredWasMadeEmpty(
                                      objectIndex,
                                      field
                                    )
                                  }
                                },
                                [
                                  _c("v-checkbox", {
                                    staticClass: "multi-selection-checkbox",
                                    attrs: {
                                      "input-value": _vm.getValue(
                                        object,
                                        field
                                      ),
                                      color: "accent",
                                      ripple: false,
                                      disabled: !_vm.editMode,
                                      "false-value": 0,
                                      "true-value": 1,
                                      "hide-details": true,
                                      disableFuzzyMatching: ""
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.setValue(
                                          objectIndex,
                                          field,
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              })
            ],
            2
          )
        : _c("div", { staticClass: "table-warning" }, [
            _vm._v(
              "\n    There are no customers premises discriminated in this building.\n  "
            )
          ]),
      _vm._v(" "),
      _c("loading-spinner", {
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "accent",
          "background-color": "transparent"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-662752d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662752d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/CustomerPremises/CustomerPremisesTable.vue
// module id = null
// module chunks = 